import { render, staticRenderFns } from "./PresentsTable.vue?vue&type=template&id=8b79c79e&"
import script from "./PresentsTable.vue?vue&type=script&lang=js&"
export * from "./PresentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports